import { render, staticRenderFns } from "./referrer-talks-list.vue?vue&type=template&id=8f207c00&scoped=true&"
import script from "./referrer-talks-list.vue?vue&type=script&lang=js&"
export * from "./referrer-talks-list.vue?vue&type=script&lang=js&"
import style0 from "./referrer-talks-list.vue?vue&type=style&index=0&id=8f207c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f207c00",
  null
  
)

export default component.exports